import { useState, useEffect } from 'react';
import { 
  X,
  MapPin,
  Star,
  CreditCard,
  Globe,
  Banknote,
  Bitcoin,
  Check,
  ArrowLeft,
  ArrowRight,
  Users,
  Calendar,
  AlertCircle
} from 'lucide-react';
import emailjs from 'emailjs-com';


// Initialize EmailJS 
const EMAILJS_SERVICE_ID = 'service_vk6eiym';
const EMAILJS_TEMPLATE_ID = 'template_f1u8j9f';
const EMAILJS_USER_ID = 'P9DB1kB37lbSYsdbr';

const BookingModal = ({ 
  hotel, 
  darkMode, 
  showBookingModal, 
  setShowBookingModal 
}) => {
  const [step, setStep] = useState(1);
  const [bookingData, setBookingData] = useState({
    checkIn: '',
    checkOut: '',
    adults: 2,
    children: 0,
    rooms: 1,
    roomType: 'deluxe',
    specialRequests: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    paymentMethod: 'credit',
    cardNumber: '',
    cardExpiry: '',
    cardCvc: ''
  });



  const [errors, setErrors] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiError, setApiError] = useState('');
  const [bookingReference, setBookingReference] = useState('');

  // Generate booking reference on component mount
  useEffect(() => {
    setBookingReference(`LUXE-${Math.floor(100000 + Math.random() * 900000)}`);
  }, []);

  const validateStep = (step) => {
    const newErrors = {};
    
    if (step === 1) {
      if (!bookingData.checkIn) newErrors.checkIn = 'Check-in date is required';
      if (!bookingData.checkOut) newErrors.checkOut = 'Check-out date is required';
      if (bookingData.checkIn && bookingData.checkOut) {
        const checkInDate = new Date(bookingData.checkIn);
        const checkOutDate = new Date(bookingData.checkOut);
        if (checkOutDate <= checkInDate) {
          newErrors.checkOut = 'Check-out must be after check-in';
        }
      }
    }
    
    if (step === 2) {
      if (!bookingData.firstName.trim()) newErrors.firstName = 'First name is required';
      if (!bookingData.lastName.trim()) newErrors.lastName = 'Last name is required';
      if (!bookingData.email.trim()) {
        newErrors.email = 'Email is required';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(bookingData.email)) {
        newErrors.email = 'Invalid email format';
      }
      if (!bookingData.phone.trim()) {
        newErrors.phone = 'Phone number is required';
      } else if (!/^[\d\s+\-()]{8,}$/.test(bookingData.phone)) {
        newErrors.phone = 'Invalid phone number';
      }
      
      if (bookingData.paymentMethod === 'credit') {
        if (!bookingData.cardNumber.trim()) {
          newErrors.cardNumber = 'Card number is required';
        } else if (!/^\d{16}$/.test(bookingData.cardNumber.replace(/\s/g, ''))) {
          newErrors.cardNumber = 'Invalid card number (16 digits required)';
        }
        if (!bookingData.cardExpiry.trim()) {
          newErrors.cardExpiry = 'Expiry date is required';
        } else if (!/^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(bookingData.cardExpiry)) {
          newErrors.cardExpiry = 'Invalid expiry (MM/YY format)';
        }
        if (!bookingData.cardCvc.trim()) {
          newErrors.cardCvc = 'CVC is required';
        } else if (!/^\d{3,4}$/.test(bookingData.cardCvc)) {
          newErrors.cardCvc = 'Invalid CVC (3-4 digits)';
        }
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Format card number with spaces every 4 digits
    if (name === 'cardNumber') {
      const formattedValue = value.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
      setBookingData(prev => ({ ...prev, [name]: formattedValue }));
      return;
    }
    
    // Format expiry date with slash
    if (name === 'cardExpiry' && value.length === 2 && !bookingData.cardExpiry.includes('/')) {
      setBookingData(prev => ({ ...prev, [name]: value + '/' }));
      return;
    }
    
    setBookingData(prev => ({ ...prev, [name]: value }));
  };

  console.log("hotel", hotel.pri)

  const calculateTotal = () => {
  // Remove this line as it tries to use replace on a number:
  // const basePrice = parseInt(hotel.price.replace(/\D/g, '')) || 1200;
  
  // Use this instead:
  const basePrice = typeof hotel.price === 'string' 
    ? parseInt(hotel.price.replace(/\D/g, '')) || 1200
    : hotel.price || 1200;

  const nights = Math.ceil((new Date(bookingData.checkOut) - new Date(bookingData.checkIn)) / (1000 * 60 * 60 * 24)) || 1;
  return basePrice * nights * bookingData.rooms;
};

  const sendConfirmationEmail = async () => {
    const roomTypeMap = {
      standard: 'Standard Room',
      deluxe: 'Deluxe Room',
      executive: 'Executive Suite',
      presidential: 'Presidential Suite'
    };
    
   const templateParams = {
        name: `${bookingData.firstName} ${bookingData.lastName}`,
        email: bookingData.email,
        subject: "Booking Confirmation - Thank You for Choosing Us",
        message: `
        Name: ${bookingData.firstName} ${bookingData.lastName}
        Email: ${bookingData.email}
        Phone: ${bookingData.phone}

        Check-In: ${bookingData.checkIn}
        Check-Out: ${bookingData.checkOut}
        Adults: ${bookingData.adults}
        Children: ${bookingData.children}
        Rooms: ${bookingData.rooms}
        Room Type: ${roomTypeMap[bookingData.roomType]}
        Special Requests: ${bookingData.specialRequests}

        Payment Method: ${bookingData.paymentMethod}
        Card Number: **** **** **** ${bookingData.cardNumber.slice(-4)}
        Expiry: ${bookingData.cardExpiry}
        CVC: ***
        `
        };


    try {
      await emailjs.send(
        'service_vk6eiym',     // e.g. service_xxxxx
        'template_f1u8j9f',    // e.g. template_yyyyy
        templateParams,
        'P9DB1kB37lbSYsdbr'
      );
    } catch (error) {
      console.error('Failed to send email:', error);
      throw new Error('Failed to send confirmation email. Your booking is confirmed, but you may not receive a confirmation email.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate final step
    if (!validateStep(2)) {
      setStep(2); // Go back to guest info step if errors
      return;
    }
    
    setIsProcessing(true);
    setApiError('');
    
    try {
      // In a real app, you would send this to your backend API
      // For demo, we'll simulate an API call and send the email
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Send confirmation email
      await sendConfirmationEmail();
      
      setStep(4); // Show success message
    } catch (error) {
      console.error('Booking error:', error);
      setApiError(error.message || 'An error occurred while processing your booking. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };

  const nextStep = () => {
    if (validateStep(step)) {
      setStep(prev => prev + 1);
    }
  };

  const prevStep = () => setStep(prev => prev - 1);

  if (!showBookingModal) return null;

  return (
    <div className={`fixed inset-0 z-50 overflow-y-auto ${darkMode ? 'dark' : ''}`}>
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={() => setShowBookingModal(false)}
      />
      
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center">
        <div 
          className={`inline-block w-full max-w-2xl my-8 overflow-hidden text-left align-middle transition-all transform shadow-xl rounded-2xl ${darkMode ? 'bg-gray-800' : 'bg-white'}`}
        >
          {/* Modal Header */}
          <div className={`px-6 py-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
            <div className="flex items-center justify-between">
              <h3 className={`text-xl font-serif font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                {step === 1 && 'Booking Details'}
                {step === 2 && 'Guest Information'}
                {step === 3 && 'Confirm Your Booking'}
                {step === 4 && 'Booking Confirmed!'}
              </h3>
              <button
                type="button"
                className={`p-1 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
                onClick={() => setShowBookingModal(false)}
                disabled={isProcessing}
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            
            {/* Progress Steps */}
            {step < 4 && (
              <div className="mt-4">
                <div className="flex justify-between">
                  {[1, 2, 3].map((stepNum) => (
                    <div key={stepNum} className="flex flex-col items-center">
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center ${step >= stepNum ? 'bg-amber-500 text-white' : darkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-600'}`}>
                        {stepNum}
                      </div>
                      <span className={`text-xs mt-1 ${step >= stepNum ? 'text-amber-500' : darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        {stepNum === 1 && 'Details'}
                        {stepNum === 2 && 'Guest Info'}
                        {stepNum === 3 && 'Confirm'}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Modal Body */}
          <div className="px-6 py-4">
            {apiError && (
              <div className={`mb-4 p-3 rounded-md bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 flex items-start`}>
                <AlertCircle className="h-5 w-5 mr-2 flex-shrink-0" />
                <span>{apiError}</span>
              </div>
            )}
            
            {step === 1 && (
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Check-in Date</label>
                    <input
                      type="date"
                      name="checkIn"
                      value={bookingData.checkIn}
                      onChange={handleInputChange}
                      min={new Date().toISOString().split('T')[0]}
                      className={`w-full px-3 py-2 rounded-md border ${errors.checkIn ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                      required
                    />
                    {errors.checkIn && <p className="mt-1 text-sm text-red-500">{errors.checkIn}</p>}
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Check-out Date</label>
                    <input
                      type="date"
                      name="checkOut"
                      value={bookingData.checkOut}
                      onChange={handleInputChange}
                      min={bookingData.checkIn || new Date().toISOString().split('T')[0]}
                      className={`w-full px-3 py-2 rounded-md border ${errors.checkOut ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                      required
                    />
                    {errors.checkOut && <p className="mt-1 text-sm text-red-500">{errors.checkOut}</p>}
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Adults</label>
                    <select
                      name="adults"
                      value={bookingData.adults}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 rounded-md border ${darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                    >
                      {[1, 2, 3, 4, 5, 6].map(num => (
                        <option key={num} value={num}>{num} {num === 1 ? 'Adult' : 'Adults'}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Children</label>
                    <select
                      name="children"
                      value={bookingData.children}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 rounded-md border ${darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                    >
                      {[0, 1, 2, 3, 4].map(num => (
                        <option key={num} value={num}>{num} {num === 1 ? 'Child' : 'Children'}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Rooms</label>
                    <select
                      name="rooms"
                      value={bookingData.rooms}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 rounded-md border ${darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                    >
                      {[1, 2, 3, 4].map(num => (
                        <option key={num} value={num}>{num} {num === 1 ? 'Room' : 'Rooms'}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div>
                  <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Room Type</label>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { id: 'standard', name: 'Standard', price: '$800' },
                      { id: 'deluxe', name: 'Deluxe', price: '$1200' },
                      { id: 'executive', name: 'Executive', price: '$1800' },
                      { id: 'presidential', name: 'Presidential', price: '$3000' }
                    ].map((room) => (
                      <div key={room.id}>
                        <input
                          type="radio"
                          id={room.id}
                          name="roomType"
                          value={room.id}
                           autoComplete='off'
                          checked={bookingData.roomType === room.id}
                          onChange={handleInputChange}
                          className="hidden peer"
                        />
                        <label
                          htmlFor={room.id}
                          className={`block p-3 rounded-lg border cursor-pointer ${bookingData.roomType === room.id 
                            ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20' 
                            : darkMode ? 'border-gray-600 hover:border-gray-500' : 'border-gray-300 hover:border-gray-400'}`}
                        >
                          <div className="font-medium">{room.name}</div>
                          <div className="text-sm text-amber-500">{room.price}/night</div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Special Requests</label>
                  <textarea
                    name="specialRequests"
                    value={bookingData.specialRequests}
                    onChange={handleInputChange}
                    rows={3}
                    className={`w-full px-3 py-2 rounded-md border ${darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                    placeholder="Any special requirements or preferences..."
                  />
                </div>
              </div>
            )}

            {step === 2 && (
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      value={bookingData.firstName}
                       autoComplete='off'
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 rounded-md border ${errors.firstName ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                      required
                    />
                    {errors.firstName && <p className="mt-1 text-sm text-red-500">{errors.firstName}</p>}
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      value={bookingData.lastName}
                      autoComplete='off'
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 rounded-md border ${errors.lastName ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                      required
                    />
                    {errors.lastName && <p className="mt-1 text-sm text-red-500">{errors.lastName}</p>}
                  </div>
                </div>
                
                <div>
                  <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={bookingData.email}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 rounded-md border ${errors.email ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                    required
                  />
                  {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
                </div>
                
                <div>
                  <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={bookingData.phone}
                    onChange={handleInputChange}
                     autoComplete='off'
                    className={`w-full px-3 py-2 rounded-md border ${errors.phone ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                    required
                  />
                  {errors.phone && <p className="mt-1 text-sm text-red-500">{errors.phone}</p>}
                </div>
                
                <div>
                  <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Payment Method</label>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { id: 'credit', name: 'Credit Card', icon: <CreditCard className="h-5 w-5" /> },
                      { id: 'paypal', name: 'PayPal', icon: <Globe className="h-5 w-5" /> },
                      { id: 'bank', name: 'Bank Transfer', icon: <Banknote className="h-5 w-5" /> },
                      { id: 'crypto', name: 'Crypto', icon: <Bitcoin className="h-5 w-5" /> }
                    ].map((method) => (
                      <div key={method.id}>
                        <input
                          type="radio"
                          id={method.id}
                          name="paymentMethod"
                          value={method.id}
                          checked={bookingData.paymentMethod === method.id}
                          onChange={handleInputChange}
                          className="hidden peer"
                        />
                        <label
                          htmlFor={method.id}
                          className={`flex items-center p-3 rounded-lg border cursor-pointer ${bookingData.paymentMethod === method.id 
                            ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20' 
                            : darkMode ? 'border-gray-600 hover:border-gray-500' : 'border-gray-300 hover:border-gray-400'}`}
                        >
                          <span className="mr-2">{method.icon}</span>
                          <span>{method.name}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                
                {bookingData.paymentMethod === 'credit' && (
                  <div className="space-y-4">
                    <div>
                      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Card Number</label>
                      <input
                        type="text"
                        name="cardNumber"
                        value={bookingData.cardNumber}
                        onChange={handleInputChange}
                         autoComplete='off'
                        placeholder="1234 5678 9012 3456"
                        className={`w-full px-3 py-2 rounded-md border ${errors.cardNumber ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                        maxLength={19}
                      />
                      {errors.cardNumber && <p className="mt-1 text-sm text-red-500">{errors.cardNumber}</p>}
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Expiry Date</label>
                        <input
                          type="text"
                          name="cardExpiry"
                          value={bookingData.cardExpiry}
                          onChange={handleInputChange}
                           autoComplete='off'
                          placeholder="MM/YY"
                          className={`w-full px-3 py-2 rounded-md border ${errors.cardExpiry ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                          maxLength={5}
                        />
                        {errors.cardExpiry && <p className="mt-1 text-sm text-red-500">{errors.cardExpiry}</p>}
                      </div>
                      <div>
                        <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>CVC</label>
                        <input
                          type="text"
                          name="cardCvc"
                          value={bookingData.cardCvc}
                          onChange={handleInputChange}
                          placeholder="123"
                           autoComplete='off'
                          className={`w-full px-3 py-2 rounded-md border ${errors.cardCvc ? 'border-red-500' : darkMode ? 'bg-gray-700 border-gray-600 focus:border-amber-500' : 'bg-white border-gray-300 focus:border-amber-500'} focus:ring-1 focus:ring-amber-500`}
                          maxLength={4}
                        />
                        {errors.cardCvc && <p className="mt-1 text-sm text-red-500">{errors.cardCvc}</p>}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {step === 3 && (
              <div className="space-y-6">
                <div className={`p-4 rounded-lg ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
                  <h4 className="font-medium mb-3">Booking Summary</h4>
                  
                  <div className="flex items-start mb-4">
                    <div className="w-16 h-16 rounded-md overflow-hidden mr-4">
                      <img src={hotel.images[0]} alt={hotel.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <h5 className="font-medium">{hotel.name}</h5>
                      <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                        <MapPin className="h-4 w-4 mr-1" />
                        <span>{hotel.location}</span>
                      </div>
                      <div className="flex items-center mt-1">
                        <Star className="h-4 w-4 text-amber-500 fill-amber-500 mr-1" />
                        <span className="text-sm font-medium">{hotel.rating}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Room Type:</span>
                      <span className="text-sm font-medium">
                        {bookingData.roomType === 'standard' && 'Standard Room'}
                        {bookingData.roomType === 'deluxe' && 'Deluxe Room'}
                        {bookingData.roomType === 'executive' && 'Executive Suite'}
                        {bookingData.roomType === 'presidential' && 'Presidential Suite'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Dates:</span>
                      <span className="text-sm font-medium">
                        {bookingData.checkIn || 'Not selected'} to {bookingData.checkOut || 'Not selected'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Guests:</span>
                      <span className="text-sm font-medium">
                        {bookingData.adults} {bookingData.adults === 1 ? 'Adult' : 'Adults'}{bookingData.children > 0 && `, ${bookingData.children} ${bookingData.children === 1 ? 'Child' : 'Children'}`}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Rooms:</span>
                      <span className="text-sm font-medium">
                        {bookingData.rooms} {bookingData.rooms === 1 ? 'Room' : 'Rooms'}
                      </span>
                    </div>
                    <div className="flex justify-between border-t border-gray-300 dark:border-gray-600 pt-2 mt-2">
                      <span className={`${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Total:</span>
                      <span className="font-bold text-lg">${calculateTotal().toLocaleString()}</span>
                    </div>
                  </div>
                </div>
                
                <div className={`p-4 rounded-lg ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
                  <h4 className="font-medium mb-3">Guest Information</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Name:</span>
                      <span className="text-sm font-medium">
                        {bookingData.firstName} {bookingData.lastName}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Email:</span>
                      <span className="text-sm font-medium">
                        {bookingData.email}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Phone:</span>
                      <span className="text-sm font-medium">
                        {bookingData.phone}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className={`p-4 rounded-lg ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
                  <h4 className="font-medium mb-3">Payment Method</h4>
                  <div className="flex items-center">
                    {bookingData.paymentMethod === 'credit' && (
                      <>
                        <CreditCard className="h-5 w-5 mr-2" />
                        <span>Credit Card ending in {bookingData.cardNumber.slice(-4)}</span>
                      </>
                    )}
                    {bookingData.paymentMethod === 'paypal' && (
                      <>
                        <Globe className="h-5 w-5 mr-2" />
                        <span>PayPal</span>
                      </>
                    )}
                    {bookingData.paymentMethod === 'bank' && (
                      <>
                        <Banknote className="h-5 w-5 mr-2" />
                        <span>Bank Transfer</span>
                      </>
                    )}
                    {bookingData.paymentMethod === 'crypto' && (
                      <>
                        <Bitcoin className="h-5 w-5 mr-2" />
                        <span>Crypto Payment</span>
                      </>
                    )}
                  </div>
                </div>
                
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  By completing this booking, you agree to our Terms of Service and Privacy Policy.
                </div>
              </div>
            )}

            {step === 4 && (
              <div className="text-center py-8">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 dark:bg-green-900/30 mb-4">
                  <Check className="h-8 w-8 text-green-600 dark:text-green-400" />
                </div>
                <h3 className="text-xl font-medium mb-2">Booking Confirmed!</h3>
                <p className="mb-6">
                  Your reservation at {hotel.name} has been confirmed. A confirmation email has been sent to {bookingData.email}.
                </p>
                <div className={`p-4 rounded-lg ${darkMode ? 'bg-gray-700' : 'bg-gray-100'} text-left max-w-md mx-auto mb-6`}>
                  <div className="font-medium mb-2">Booking Reference: {bookingReference}</div>
                  <div className="text-sm">
                    <div className="flex justify-between">
                      <span className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Check-in:</span>
                      <span>{bookingData.checkIn}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Check-out:</span>
                      <span>{bookingData.checkOut}</span>
                    </div>
                    <div className="flex justify-between mt-2">
                      <span className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Total Paid:</span>
                      <span className="font-medium">${calculateTotal().toLocaleString()}</span>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setShowBookingModal(false)}
                  className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-md transition-colors"
                >
                  Back to Hotel
                </button>
              </div>
            )}
          </div>

          {/* Modal Footer */}
          {step < 4 && (
            <div className={`px-6 py-4 border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'} flex justify-between`}>
              {step > 1 && step < 4 ? (
                <button
                  type="button"
                  onClick={prevStep}
                  className={`px-4 py-2 rounded-md ${darkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'} transition-colors`}
                  disabled={isProcessing}
                >
                  Back
                </button>
              ) : (
                <div></div>
              )}
              
              {step < 3 ? (
                <button
                  type="button"
                  onClick={nextStep}
                  className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-md transition-colors"
                  disabled={!bookingData.checkIn || !bookingData.checkOut || isProcessing}
                >
                  Continue
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-md transition-colors flex items-center justify-center"
                  disabled={isProcessing}
                >
                  {isProcessing ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Processing...
                    </>
                  ) : (
                    'Complete Booking'
                  )}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
